import { createFocusTrap, renderCartDrawer } from '@theme/utils';

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleToggle = this.handleToggle.bind(this);
    this.focusTrap = createFocusTrap(this);
  }

  connectedCallback() {
    this.addEventListener('toggle', this.handleToggle);
    this.addEventListener('click', this.handleBackdropClick.bind(this));
    this.updateTabindex(false);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.handleToggle);
    this.focusTrap.disable();
  }

  handleToggle() {
    // Check if popover is open
    const isOpen = this.matches(':popover-open');
    this.updateTabindex(isOpen);

    // Enable/disable focus trap
    if (isOpen) {
      this.focusTrap.enable();

      // When opening, focus the close button for accessibility
      const closeButton = this.querySelector('.cart-drawer__close');
      if (closeButton) {
        // Use setTimeout to ensure popover animation has started
        setTimeout(() => {
          closeButton.focus();
        }, 0);
      }
    } else {
      this.focusTrap.disable();
    }
  }

  handleBackdropClick(event) {
    if (event.target === this) {
      this.hidePopover();
    }
  }

  updateTabindex(isOpen) {
    // Find all focusable elements inside the drawer
    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    const focusableElements = this.querySelectorAll(focusableSelectors);

    focusableElements.forEach(element => {
      if (isOpen) {
        // Restore natural tabindex when open
        // If element had a saved tabindex, restore it, otherwise remove the attribute
        if (element.dataset.savedTabindex !== undefined) {
          element.tabIndex = parseInt(element.dataset.savedTabindex, 10);
          delete element.dataset.savedTabindex;
        } else if (element.hasAttribute('tabindex')) {
          element.removeAttribute('tabindex');
        }
      } else {
        // Save current tabindex and set to -1 when closed
        if (element.hasAttribute('tabindex')) {
          element.dataset.savedTabindex = element.tabIndex;
        }
        element.tabIndex = -1;
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
